(() => {
  if (window.__xenithCoreAnalyticsLoaded) return;
  window.__xenithCoreAnalyticsLoaded = true;
  const completed = new Set();
  let sequence = 0;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const context = () => ({
    brand: 'XENITH CORE',
    page_kind: document.querySelector('[data-xenith-scope="pdp"]') ? 'product' :
      document.querySelector('[data-xenith-scope="collection"]') ? 'collection' :
      document.body.dataset.xcPage === 'cart' ? 'cart' :
        document.querySelector('.xc-tmhero,.xc-hero') ? 'lp' : document.body.dataset.xcPage || 'other',
    device: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop',
    sale_state: document.querySelector('[data-xc-sale-state]')?.dataset.xcSaleState ||
      (document.querySelector('[data-normal-cart-config]') ? 'priority_entry' :
        document.querySelector('[data-xc-general-sale]')?.dataset.xcGeneralSale || 'unverified'),
    stock_state: document.querySelector('input[data-xc-stock-state]:checked')?.dataset.xcStockState ||
      document.querySelector('[data-xc-stock-state]')?.dataset.xcStockState || 'unverified',
    currency: document.body.dataset.xcCurrency || ''
  });
  // Custom events do not duplicate Shopify's standard add_to_cart/purchase events.
  const emit = (event, fields = {}) => {
    if (!allowed()) return;
    const payload = { event, ...context(), ...fields };
    (window.dataLayer = window.dataLayer || []).push(payload);
    window.dispatchEvent(new CustomEvent('xenith-core:event', { detail: payload }));
  };
  const safeItems = (response) => (Array.isArray(response?.items) ? response.items : [response])
    .filter((item) => item && Number(item.variant_id || item.id) > 0 && Number(item.quantity) > 0)
    .map((item) => ({
      item_id: String(item.product_id || ''),
      item_variant: String(item.variant_id || item.id),
      quantity: Number(item.quantity),
      price_minor: Number(item.final_price ?? item.price ?? 0)
    }));
  window.XCCartEvents = {
    request() {
      const requestId = Date.now().toString(36) + '-' + (++sequence);
      emit('xc_cart_add_request');
      return requestId;
    },
    success(requestId, response, requested) {
      if (!requestId || completed.has(requestId)) return;
      completed.add(requestId);
      if (completed.size > 100) completed.delete(completed.values().next().value);
      const items = safeItems(response);
      if (Array.isArray(requested)) items.forEach((item) => {
        const match = requested.find((entry) => String(entry.id) === item.item_variant);
        if (match) item.quantity = Number(match.quantity);
      });
      if (!items.length) return;
      emit('xc_cart_add_success', { items });
      document.dispatchEvent(new CustomEvent('xc:cart:success', { detail: { items } }));
    },
    failure(requestId, reason = 'request_failed') {
      if (!requestId || completed.has(requestId)) return;
      completed.add(requestId);
      emit('xc_cart_add_failure', { reason: reason === 'stock' ? 'stock' : 'request_failed' });
    }
  };
  document.addEventListener('click', (event) => {
    if (!document.body.hasAttribute('data-xc-storefront')) return;
    const target = event.target.closest('button,a,input');
    if (!target) return;
    if (target.matches('[data-xc-add],[data-xc-card-add],[name="add"],[data-xc-sticky-atc]')) emit('xc_purchase_click');
    if (target.matches('[name="checkout"],[data-xc-spbar-checkout]')) emit('xc_checkout_start');
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches?.('[data-xenith-form]')) return;
    if (/cart\/add/.test(form.action || '')) return;
    emit('xc_registration_attempt'); // A submit is never proof of registration success.
  });
  if (document.body.dataset.xcPage === 'cart') emit('xc_cart_view');
})();
